export const WIZARD = {};